import { createSelector } from 'reselect'
import getNextTierInfoLoyaltySelect from 'modules/loyalty/redux/selectors/get-next-tier-info'

const getNextTierNameLoyaltySelect = createSelector(
  getNextTierInfoLoyaltySelect,
  /**
   * @param {NextTierInfo} nextTierInfo
   */
  nextTierInfo => {
    return nextTierInfo?.next_tier_name
  }
)

export default getNextTierNameLoyaltySelect
